BaseView = require('base/view')
UserManagement = require('src/components/users/management').default
ReactComponent  = require('src/ReactComponent').default

class UserManagementView extends BaseView
  template: _.template('<div class="user-management"></div>')

  regions:
    container : '.user-management'

  initialize: (options) =>
    { @qs } = options
    @qs.setFragment('users')

  onRender: =>
    selectedAccountId = if @user().getSelectedSupportAccountId() then parseInt(@user().getSelectedSupportAccountId()) else null
    @showChildView('container', new ReactComponent({
      component: UserManagement
      props: {
        selectedAccountId: selectedAccountId
        userAccountId: parseInt(@user().get('accountId'))
      }}))

module.exports = UserManagementView
